module.exports = __webpack_public_path__ + "static/IMG_4978-95fd2c43717c7710fe70d40908030fc9.jpg";